// @generated by protoc-gen-es v2.5.1 with parameter "target=ts,json_types=true"
// @generated from file tag/v1/tag.proto (package tag.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AssetFilter, AssetFilterJson } from "../../asset/v1/asset_pb";
import { file_asset_v1_asset } from "../../asset/v1/asset_pb";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import type { PaginationArguments, PaginationArgumentsJson, PaginationPageInfo, PaginationPageInfoJson } from "../../common/v1/pagination_pb";
import { file_common_v1_pagination } from "../../common/v1/pagination_pb";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file tag/v1/tag.proto.
 */
export const file_tag_v1_tag: GenFile =
	/*@__PURE__*/
	fileDesc(
		"ChB0YWcvdjEvdGFnLnByb3RvEgZ0YWcudjEikwEKA1RhZxIKCgJpZBgBIAEoCRIMCgRuYW1lGAIgASgJEi4KCmNyZWF0ZWRfYXQYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEjMKCnVwZGF0ZWRfYXQYBiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSACIAQFCDQoLX3VwZGF0ZWRfYXQiTwoQQ3JlYXRlVGFnUmVxdWVzdBISCghhc3NldF9pZBgBIAEoCUgAEhMKCWZvbGRlcl9pZBgCIAEoCUgAEgwKBG5hbWUYAyABKAlCBAoCaWQiUAoRQ3JlYXRlVGFnc1JlcXVlc3QSEgoIYXNzZXRfaWQYASABKAlIABITCglmb2xkZXJfaWQYAiABKAlIABIMCgR0YWdzGAMgAygJQgQKAmlkIh4KEERlbGV0ZVRhZ1JlcXVlc3QSCgoCaWQYASABKAkiUAoRRGVsZXRlVGFnc1JlcXVlc3QSEgoIYXNzZXRfaWQYASABKAlIABITCglmb2xkZXJfaWQYAiABKAlIABIMCgR0YWdzGAMgAygJQgQKAmlkItEBCg9MaXN0VGFnc1JlcXVlc3QSEAoGb3JnX2lkGAEgASgJSAASFgoMd29ya3NwYWNlX2lkGAIgASgJSAASEwoJZm9sZGVyX2lkGAMgASgJSAASKgoGZmlsdGVyGAQgASgLMhUuYXNzZXQudjEuQXNzZXRGaWx0ZXJIAYgBARI1CghwYWdpbmF0ZRgFIAEoCzIeLmNvbW1vbi52MS5QYWdpbmF0aW9uQXJndW1lbnRzSAKIAQFCBAoCaWRCCQoHX2ZpbHRlckILCglfcGFnaW5hdGUiLQoRQ3JlYXRlVGFnUmVzcG9uc2USGAoDdGFnGAEgASgLMgsudGFnLnYxLlRhZyIvChJDcmVhdGVUYWdzUmVzcG9uc2USGQoEdGFncxgBIAMoCzILLnRhZy52MS5UYWciEwoRRGVsZXRlVGFnUmVzcG9uc2UiFAoSRGVsZXRlVGFnc1Jlc3BvbnNlIlIKEExpc3RUYWdzUmVzcG9uc2USDAoEdGFncxgBIAMoCRIwCglwYWdlX2luZm8YAiABKAsyHS5jb21tb24udjEuUGFnaW5hdGlvblBhZ2VJbmZvMvkDCgpUYWdTZXJ2aWNlElsKCUNyZWF0ZVRhZxIYLnRhZy52MS5DcmVhdGVUYWdSZXF1ZXN0GhkudGFnLnYxLkNyZWF0ZVRhZ1Jlc3BvbnNlIhnC7RoCCAKC0+STAg06ASoiCC92MS90YWdzEmsKCkNyZWF0ZVRhZ3MSGS50YWcudjEuQ3JlYXRlVGFnc1JlcXVlc3QaGi50YWcudjEuQ3JlYXRlVGFnc1Jlc3BvbnNlIibC7RoCCAKC0+STAho6ASoiFS92MS90YWdzL2JhdGNoLWNyZWF0ZRJdCglEZWxldGVUYWcSGC50YWcudjEuRGVsZXRlVGFnUmVxdWVzdBoZLnRhZy52MS5EZWxldGVUYWdSZXNwb25zZSIbwu0aAggCgtPkkwIPKg0vdjEvdGFncy97aWR9EmsKCkRlbGV0ZVRhZ3MSGS50YWcudjEuRGVsZXRlVGFnc1JlcXVlc3QaGi50YWcudjEuRGVsZXRlVGFnc1Jlc3BvbnNlIibC7RoCCAKC0+STAho6ASoiFS92MS90YWdzL2JhdGNoLWRlbGV0ZRJVCghMaXN0VGFncxIXLnRhZy52MS5MaXN0VGFnc1JlcXVlc3QaGC50YWcudjEuTGlzdFRhZ3NSZXNwb25zZSIWwu0aAggCgtPkkwIKEggvdjEvdGFnc2IGcHJvdG8z",
		[file_asset_v1_asset, file_common_v1_annotations, file_common_v1_pagination, file_google_api_annotations, file_google_protobuf_timestamp],
	);

/**
 * @generated from message tag.v1.Tag
 */
export type Tag = Message<"tag.v1.Tag"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 5;
	 */
	createdAt?: Timestamp;

	/**
	 * @generated from field: optional google.protobuf.Timestamp updated_at = 6;
	 */
	updatedAt?: Timestamp;
};

/**
 * @generated from message tag.v1.Tag
 */
export type TagJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 5;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: optional google.protobuf.Timestamp updated_at = 6;
	 */
	updatedAt?: TimestampJson;
};

/**
 * Describes the message tag.v1.Tag.
 * Use `create(TagSchema)` to create a new message.
 */
export const TagSchema: GenMessage<Tag, { jsonType: TagJson }> = /*@__PURE__*/ messageDesc(file_tag_v1_tag, 0);

/**
 * Requests
 *
 * @generated from message tag.v1.CreateTagRequest
 */
export type CreateTagRequest = Message<"tag.v1.CreateTagRequest"> & {
	/**
	 * @generated from oneof tag.v1.CreateTagRequest.id
	 */
	id:
		| {
				/**
				 * @generated from field: string asset_id = 1;
				 */
				value: string;
				case: "assetId";
		  }
		| {
				/**
				 * @generated from field: string folder_id = 2;
				 */
				value: string;
				case: "folderId";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * @generated from field: string name = 3;
	 */
	name: string;
};

/**
 * Requests
 *
 * @generated from message tag.v1.CreateTagRequest
 */
export type CreateTagRequestJson = {
	/**
	 * @generated from field: string asset_id = 1;
	 */
	assetId?: string;

	/**
	 * @generated from field: string folder_id = 2;
	 */
	folderId?: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name?: string;
};

/**
 * Describes the message tag.v1.CreateTagRequest.
 * Use `create(CreateTagRequestSchema)` to create a new message.
 */
export const CreateTagRequestSchema: GenMessage<CreateTagRequest, { jsonType: CreateTagRequestJson }> = /*@__PURE__*/ messageDesc(file_tag_v1_tag, 1);

/**
 * @generated from message tag.v1.CreateTagsRequest
 */
export type CreateTagsRequest = Message<"tag.v1.CreateTagsRequest"> & {
	/**
	 * @generated from oneof tag.v1.CreateTagsRequest.id
	 */
	id:
		| {
				/**
				 * @generated from field: string asset_id = 1;
				 */
				value: string;
				case: "assetId";
		  }
		| {
				/**
				 * @generated from field: string folder_id = 2;
				 */
				value: string;
				case: "folderId";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * @generated from field: repeated string tags = 3;
	 */
	tags: string[];
};

/**
 * @generated from message tag.v1.CreateTagsRequest
 */
export type CreateTagsRequestJson = {
	/**
	 * @generated from field: string asset_id = 1;
	 */
	assetId?: string;

	/**
	 * @generated from field: string folder_id = 2;
	 */
	folderId?: string;

	/**
	 * @generated from field: repeated string tags = 3;
	 */
	tags?: string[];
};

/**
 * Describes the message tag.v1.CreateTagsRequest.
 * Use `create(CreateTagsRequestSchema)` to create a new message.
 */
export const CreateTagsRequestSchema: GenMessage<CreateTagsRequest, { jsonType: CreateTagsRequestJson }> = /*@__PURE__*/ messageDesc(file_tag_v1_tag, 2);

/**
 * @generated from message tag.v1.DeleteTagRequest
 */
export type DeleteTagRequest = Message<"tag.v1.DeleteTagRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message tag.v1.DeleteTagRequest
 */
export type DeleteTagRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message tag.v1.DeleteTagRequest.
 * Use `create(DeleteTagRequestSchema)` to create a new message.
 */
export const DeleteTagRequestSchema: GenMessage<DeleteTagRequest, { jsonType: DeleteTagRequestJson }> = /*@__PURE__*/ messageDesc(file_tag_v1_tag, 3);

/**
 * @generated from message tag.v1.DeleteTagsRequest
 */
export type DeleteTagsRequest = Message<"tag.v1.DeleteTagsRequest"> & {
	/**
	 * @generated from oneof tag.v1.DeleteTagsRequest.id
	 */
	id:
		| {
				/**
				 * @generated from field: string asset_id = 1;
				 */
				value: string;
				case: "assetId";
		  }
		| {
				/**
				 * @generated from field: string folder_id = 2;
				 */
				value: string;
				case: "folderId";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * @generated from field: repeated string tags = 3;
	 */
	tags: string[];
};

/**
 * @generated from message tag.v1.DeleteTagsRequest
 */
export type DeleteTagsRequestJson = {
	/**
	 * @generated from field: string asset_id = 1;
	 */
	assetId?: string;

	/**
	 * @generated from field: string folder_id = 2;
	 */
	folderId?: string;

	/**
	 * @generated from field: repeated string tags = 3;
	 */
	tags?: string[];
};

/**
 * Describes the message tag.v1.DeleteTagsRequest.
 * Use `create(DeleteTagsRequestSchema)` to create a new message.
 */
export const DeleteTagsRequestSchema: GenMessage<DeleteTagsRequest, { jsonType: DeleteTagsRequestJson }> = /*@__PURE__*/ messageDesc(file_tag_v1_tag, 4);

/**
 * @generated from message tag.v1.ListTagsRequest
 */
export type ListTagsRequest = Message<"tag.v1.ListTagsRequest"> & {
	/**
	 * @generated from oneof tag.v1.ListTagsRequest.id
	 */
	id:
		| {
				/**
				 * @generated from field: string org_id = 1;
				 */
				value: string;
				case: "orgId";
		  }
		| {
				/**
				 * @generated from field: string workspace_id = 2;
				 */
				value: string;
				case: "workspaceId";
		  }
		| {
				/**
				 * @generated from field: string folder_id = 3;
				 */
				value: string;
				case: "folderId";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * @generated from field: optional asset.v1.AssetFilter filter = 4;
	 */
	filter?: AssetFilter;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 5;
	 */
	paginate?: PaginationArguments;
};

/**
 * @generated from message tag.v1.ListTagsRequest
 */
export type ListTagsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string folder_id = 3;
	 */
	folderId?: string;

	/**
	 * @generated from field: optional asset.v1.AssetFilter filter = 4;
	 */
	filter?: AssetFilterJson;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 5;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message tag.v1.ListTagsRequest.
 * Use `create(ListTagsRequestSchema)` to create a new message.
 */
export const ListTagsRequestSchema: GenMessage<ListTagsRequest, { jsonType: ListTagsRequestJson }> = /*@__PURE__*/ messageDesc(file_tag_v1_tag, 5);

/**
 * Responses
 *
 * @generated from message tag.v1.CreateTagResponse
 */
export type CreateTagResponse = Message<"tag.v1.CreateTagResponse"> & {
	/**
	 * @generated from field: tag.v1.Tag tag = 1;
	 */
	tag?: Tag;
};

/**
 * Responses
 *
 * @generated from message tag.v1.CreateTagResponse
 */
export type CreateTagResponseJson = {
	/**
	 * @generated from field: tag.v1.Tag tag = 1;
	 */
	tag?: TagJson;
};

/**
 * Describes the message tag.v1.CreateTagResponse.
 * Use `create(CreateTagResponseSchema)` to create a new message.
 */
export const CreateTagResponseSchema: GenMessage<CreateTagResponse, { jsonType: CreateTagResponseJson }> = /*@__PURE__*/ messageDesc(file_tag_v1_tag, 6);

/**
 * @generated from message tag.v1.CreateTagsResponse
 */
export type CreateTagsResponse = Message<"tag.v1.CreateTagsResponse"> & {
	/**
	 * @generated from field: repeated tag.v1.Tag tags = 1;
	 */
	tags: Tag[];
};

/**
 * @generated from message tag.v1.CreateTagsResponse
 */
export type CreateTagsResponseJson = {
	/**
	 * @generated from field: repeated tag.v1.Tag tags = 1;
	 */
	tags?: TagJson[];
};

/**
 * Describes the message tag.v1.CreateTagsResponse.
 * Use `create(CreateTagsResponseSchema)` to create a new message.
 */
export const CreateTagsResponseSchema: GenMessage<CreateTagsResponse, { jsonType: CreateTagsResponseJson }> = /*@__PURE__*/ messageDesc(file_tag_v1_tag, 7);

/**
 * @generated from message tag.v1.DeleteTagResponse
 */
export type DeleteTagResponse = Message<"tag.v1.DeleteTagResponse"> & {};

/**
 * @generated from message tag.v1.DeleteTagResponse
 */
export type DeleteTagResponseJson = {};

/**
 * Describes the message tag.v1.DeleteTagResponse.
 * Use `create(DeleteTagResponseSchema)` to create a new message.
 */
export const DeleteTagResponseSchema: GenMessage<DeleteTagResponse, { jsonType: DeleteTagResponseJson }> = /*@__PURE__*/ messageDesc(file_tag_v1_tag, 8);

/**
 * @generated from message tag.v1.DeleteTagsResponse
 */
export type DeleteTagsResponse = Message<"tag.v1.DeleteTagsResponse"> & {};

/**
 * @generated from message tag.v1.DeleteTagsResponse
 */
export type DeleteTagsResponseJson = {};

/**
 * Describes the message tag.v1.DeleteTagsResponse.
 * Use `create(DeleteTagsResponseSchema)` to create a new message.
 */
export const DeleteTagsResponseSchema: GenMessage<DeleteTagsResponse, { jsonType: DeleteTagsResponseJson }> = /*@__PURE__*/ messageDesc(file_tag_v1_tag, 9);

/**
 * @generated from message tag.v1.ListTagsResponse
 */
export type ListTagsResponse = Message<"tag.v1.ListTagsResponse"> & {
	/**
	 * @generated from field: repeated string tags = 1;
	 */
	tags: string[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo;
};

/**
 * @generated from message tag.v1.ListTagsResponse
 */
export type ListTagsResponseJson = {
	/**
	 * @generated from field: repeated string tags = 1;
	 */
	tags?: string[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message tag.v1.ListTagsResponse.
 * Use `create(ListTagsResponseSchema)` to create a new message.
 */
export const ListTagsResponseSchema: GenMessage<ListTagsResponse, { jsonType: ListTagsResponseJson }> = /*@__PURE__*/ messageDesc(file_tag_v1_tag, 10);

/**
 * Public APIs
 *
 * @generated from service tag.v1.TagService
 */
export const TagService: GenService<{
	/**
	 * // Mutations
	 *
	 * @generated from rpc tag.v1.TagService.CreateTag
	 */
	createTag: {
		methodKind: "unary";
		input: typeof CreateTagRequestSchema;
		output: typeof CreateTagResponseSchema;
	};
	/**
	 * @generated from rpc tag.v1.TagService.CreateTags
	 */
	createTags: {
		methodKind: "unary";
		input: typeof CreateTagsRequestSchema;
		output: typeof CreateTagsResponseSchema;
	};
	/**
	 * @generated from rpc tag.v1.TagService.DeleteTag
	 */
	deleteTag: {
		methodKind: "unary";
		input: typeof DeleteTagRequestSchema;
		output: typeof DeleteTagResponseSchema;
	};
	/**
	 * @generated from rpc tag.v1.TagService.DeleteTags
	 */
	deleteTags: {
		methodKind: "unary";
		input: typeof DeleteTagsRequestSchema;
		output: typeof DeleteTagsResponseSchema;
	};
	/**
	 * // Queries
	 *
	 * @generated from rpc tag.v1.TagService.ListTags
	 */
	listTags: {
		methodKind: "unary";
		input: typeof ListTagsRequestSchema;
		output: typeof ListTagsResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_tag_v1_tag, 0);
